import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    username: { email: "", firstname: "", lastname: "", role: [], phone: null },
    currentUser: null,
    loading: false,
    error: null,
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    setUsername(state, payload) {
      state.username = payload;
    },
    setcurrentUser(state, payload) {
      state.currentUser = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setError(state, payload) {
      state.error = payload;
    },
    clearError(state) {
      state.error = null;
    },
    setDrawer(state, payload) {
      state.drawer = payload;
    },
    setToolbar(state, payload) {
      state.toolbar = payload;
    },
  },
  actions: {
    autoLogin({ commit }, payload) {
      commit("setUser", { id: payload });
    },

    Name({ commit }, payload) {
      commit("setUsername", {
        firstname: payload["firstname"],
        lastname: payload["lastname"],
        email: payload["email"],
        role: payload["role"],
        phone: payload["phone"],
      });
    },

    logout({ commit }, payload) {
      return axios
        .post("/api/session/", { sub: payload.id })
        .then((response) => {
          if (response.data.loggedout == "true") {
            commit("setUser", null);
            window.location.href =
              "https://sso.definedge.com/auth/realms/definedge/protocol/openid-connect/logout?redirect_uri=https%3A%2F%2Fwww.definedge.com";
          }
        });
    },
    /* 
                changeToolbar({ commit }, payload) {
                    commit("setToolbar", {
                        toolbar: payload
                    })
                },
                changeDrawer({ commit }, payload) {
                    commit("setDrawer", {
                        drawer: payload
                    })
                } */
  },

  getters: {
    userphone: (state) => {
      //console.log('state: ', state)
      // console.log('state username: ', state.username)
      // console.log('state phone: ', state.username.phone)
      return state.username.phone;
    },

    admin: (state) => {
      //console.log('Admin role data :', state)
      // if(!state.username.role==null){
      var dummyrole = "";
      state.username.role.forEach((element) => {
        //  console.log('element :',element)
        if (element == "ROLE_ADM") {
          dummyrole = "ROLE_ADM";
        }
      });
      //console.log('Dummy role:', state.username.role)

      if (dummyrole == "ROLE_ADM") {
        //console.log('Admin role if condition')
        return true;
      } else {
        //console.log('Admin role else block')
        return false;
      }
      //  }
    },
    userdata: (state) => {
      return state;
    },
    user: (state) => {
      //console.log(' user role data :', state)
      //   if(!state.username.role==null){
      var dummyrole = "";
      state.username.role.forEach((element) => {
        //  console.log('element :',element)
        if (element == "joinlead") {
          // state.username.role ="joinlead"
          dummyrole = "joinlead";
        }
      });
      if (dummyrole == "joinlead") {
        //console.log('Joinlead role if condition')
        return false;
      } else {
        //console.log('Joinlead role else condition')
        return true;
      }
      // }
    },
  },
  modules: {},
});
